import { nextTick } from 'vue';
import { useCaretStore } from '../stores/caret_store.js';
import * as CONSTS from '../constants.js';
export default {
  computed: {
    caretStartOffset() {
      return useCaretStore().caretStartOffset;
    },
    caretEndOffset() {
      return useCaretStore().caretEndOffset;
    },
    caretPositionName() {
      return useCaretStore().caretPositionName;
    },
    caretPositionNum() {
      return useCaretStore().caretPositionNum;
    },
    preCaretStartOffset() {
      return useCaretStore().preCaretStartOffset;
    },
    preCaretEndOffset() {
      return useCaretStore().preCaretEndOffset;
    },
    preCaretPositionName() {
      return useCaretStore().preCaretPositionName;
    },
    preCaretPositionNum() {
      return useCaretStore().preCaretPositionNum;
    },
    isSelectionDelete() {
      return useCaretStore().isSelectionDelete;
    },
    composingStatus() {
      return useCaretStore().composingStatus;
    },
  },
  methods: {
    /**
     * caret位置を保持
     * @param {KeyboardEvent} event キーボードのイベント
     */
    async getCaretPosition(event = null) {
      const selection = window.getSelection(); // caret位置取得用
      let range = selection.getRangeAt(0);
      const targetNode = selection.focusNode;

      useCaretStore().caretStartOffset = range.startOffset;
      useCaretStore().caretEndOffset = range.endOffset;

      const targetIndex = parseFloat(
        targetNode.parentElement.getAttribute('separate-index')
          ? targetNode.parentElement.getAttribute('separate-index')
          : 0,
      );

      // 【備考】targetNodeがlineだとtargetElementがnull
      const targetElement = this.getTargetSentenceElement(targetNode);
      if (!targetElement) {
        event.preventDefault();
        return;
      }

      const dataType = targetElement.getAttribute('data-type');
      // ドキュメントの最初の文で上キーか右キーが押された場合の処理
      if (event && !targetElement.previousElementSibling) {
        const minOffset = Math.min(range.startOffset, range.endOffset);
        // 文頭で上キーが押された場合は何もしない
        if (event.key == 'ArrowUp' && minOffset == 0) {
          event.preventDefault();
          return;
        }
        // 右キーが押された場合
        else if (event.key == 'ArrowRight') {
          const maxCount = this.setMaxCount(dataType);
          const targetTextLength =
            dataType == 'hashira' ? targetNode.textContent.length : targetElement.textContent.length;
          // オフセットが1行分の文字数より小さいか、1行分の文字数と同じで1文の長さも同じだったら 何もしない
          // 【備考】条件を minOffset <= maxCount だけにしてしまうと、2行以上の文の2行目の先頭で右キーが押せなくなってしまう
          if (minOffset < maxCount || (minOffset == maxCount && targetTextLength == maxCount)) {
            event.preventDefault();
            return;
          }
        }
      }

      // serifuの場合は分割後の要素が「separate-serifu」となるため、separate-serifu込みで検索
      const targetTextElements = targetElement.querySelectorAll(`.${dataType}, .separate-serifu`);

      if ('hashira' == dataType) {
        useCaretStore().caretPositionName = targetNode.parentElement.getAttribute('name');
      } else {
        useCaretStore().caretPositionName = Array.from(targetTextElements)[targetIndex].getAttribute('name');
      }
    },
    /**
     * caret位置設定
     * @param {Number} caretStartOffset
     * @param {Number} caretEndOffset
     */
    async setCaretPosition(caretStartOffset, caretEndOffset) {
      const selection = window.getSelection();
      const newRange = window.getSelection().getRangeAt(0);

      const targetElements = document.getElementsByName(this.caretPositionName);
      const targetData = this.getTargetSentenceElement(targetElements[0]);

      // 前行が空だった場合は処理を行わない
      if (targetData == null) return;

      let targetNode = new Object();
      if (this.separateIndex == undefined) this.separateIndex = 0;
      targetNode = targetElements[this.separateIndex].childNodes[0];
      if (targetNode.length < caretStartOffset || targetNode.length < caretEndOffset) return;
      this.setStartEndRange(newRange, targetNode, caretStartOffset);
      this.resetRange(selection, newRange);
    },
    /**
     * caretが合っている要素が属しているタグを<ul>の子供タグまで遡って取得
     * @param {} null
     *
     */
    getTargetSentenceElement(ele) {
      let isContinue = true;
      let tmpEle = ele;
      while (isContinue) {
        if (tmpEle == null) {
          isContinue = false;
        } else if (tmpEle.parentElement == null) {
          tmpEle = null;
          isContinue = false;
        } else if (tmpEle.parentElement.tagName == 'UL') {
          isContinue = false;
        } else {
          tmpEle = tmpEle.parentElement;
        }
      }
      return tmpEle;
    },
    /**
     * 対象の要素eleの先頭にcaretselectionを移動する
     * @param {Selection} selection selection
     * @param {Element} ele targetElement
     */
    setCaretElementTop(selection, ele) {
      selection.removeAllRanges();
      const range = document.createRange();
      this.setStartEndRange(range, ele, 0);
      selection.addRange(range);
    },
    /**
     * 指定されたUUIDの要素にスクロール&カーソルを合わせる
     * @param uuid 対象要素のUUID
     */
    scrollToContent(uuid) {
      let nextFocusContentElement = document.querySelectorAll(`[data-contentid="${uuid}"]`)[0];
      const range = document.createRange();
      const selection = window.getSelection(); // caret位置取得用
      //該当uuidのcontentの先頭にカーソルを合わせる
      let nextFocusDiv = null;
      nextFocusDiv = nextFocusContentElement.querySelectorAll(`[data-index="0"]`)[0];
      range.setStart(nextFocusDiv, 0);
      range.setEnd(nextFocusDiv, 0);
      selection.removeAllRanges();
      selection.addRange(range);
      nextFocusContentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    /**
     * 柱から柱への移動
     * @param {MouseEvent} event
     *
     */
    hashiraJumpAction(key) {
      const selection = window.getSelection(); // caret位置取得用

      // 現在キャレットがあるContentを取得
      let currentContent = null;
      if (this.selectTo.contentID) {
        currentContent = this.contentMap.get(this.selectTo.contentID);
      } else {
        const targetDiv = selection.focusNode?.dataset?.contentid
          ? selection.focusNode.children[0]
          : selection.focusNode?.dataset?.index
          ? selection.focusNode
          : selection.focusNode.parentNode;
        const parentDiv = targetDiv.parentNode;
        currentContent = this.contentMap.get(parentDiv.dataset.contentid);
      }
      if (!currentContent) return;

      // ArrowRight/ArrowUp → 前方（previous方向）に辿って柱を探す
      // ArrowLeft/ArrowDown → 後方（next方向）に辿って柱を探す
      let nextFocusContent = null;
      if (key === 'ArrowRight' || key === 'ArrowUp') {
        let candidate = currentContent.previous;
        while (candidate) {
          if (candidate.tag_type === 'hashira') {
            nextFocusContent = candidate;
            break;
          }
          candidate = candidate.previous;
        }
      } else {
        // ArrowLeft or ArrowDown
        let candidate = currentContent.next;
        while (candidate) {
          if (candidate.tag_type === 'hashira') {
            nextFocusContent = candidate;
            break;
          }
          candidate = candidate.next;
        }
      }
      if (!nextFocusContent) return;
      // 選択範囲をクリア
      this.selectTo.contentID = '';
      this.selectTo.wordIndex = 0;
      this.contents.forEach((content) => {
        if (content.selectFrom != -1) content.selectFrom = -1;
        if (content.selectTo != -1) content.selectTo = -1;
      });
      // 移動先の柱の先頭にキャレットをセット&スクロール
      nextTick(() => {
        this.scrollToContent(nextFocusContent.uuid);
      });
    },
    /**
     *  選択範囲の先頭にキャレットを移動する
     *
     */
    setCaretSelectionFirst() {
      if (this.selectTo.contentID == '' || this.selectFrom.contentID == '') return;
      const selection = window.getSelection(); // caret位置取得用
      const range = document.createRange();
      let firstSelectedContent = null;
      let targetContent = this.contents[0];
      while (firstSelectedContent === null && targetContent) {
        if (targetContent.uuid == this.selectTo.contentID || targetContent.uuid == this.selectFrom.contentID) {
          firstSelectedContent = targetContent;
        } else {
          targetContent = targetContent.next;
        }
      }
      if (!firstSelectedContent) return;
      nextTick(() => {
        let nextFocusContentElements = document.querySelectorAll(`[data-contentid="${targetContent.uuid}"]`);
        let nextFocusDiv = null;
        let nextWordIndex = 0;
        if (this.selectTo.contentID == this.selectFrom.contentID) {
          nextWordIndex = Math.min(this.selectFrom.wordIndex, this.selectTo.wordIndex);
        } else {
          nextWordIndex =
            this.selectTo.contentID == targetContent.uuid ? this.selectTo.wordIndex : this.selectFrom.wordIndex;
        }
        nextFocusContentElements.forEach((ele) => {
          let selectorArray = ele.querySelectorAll(`[data-index="${Math.max(0, nextWordIndex)}"]`);
          if (selectorArray.length == 1) nextFocusDiv = selectorArray[0];
        });
        if (!nextFocusDiv) return;
        range.setStart(nextFocusDiv, 0);
        range.setEnd(nextFocusDiv, 0);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    },
  },
};
